<template>
    <LexinKeyboardLangContent :layout_content="getLayout()" :lang_header="getHeader()" @add-to-search="addToSearchInput"></LexinKeyboardLangContent>
</template>
<script>

import LexinKeyboardLangContent from "@/components/LexinKeyboardLangContent.vue";

export default {
    props: [],
    components: {
        LexinKeyboardLangContent
    },

    methods: {
        getHeader(){
            return this.$t('message.keyboard-filipino');
        },
        getLayout() {
            let layout = {
                default: [
                    '\u00f1',
                ],
                shift: []
            };

            return layout;
        },

        addToSearchInput(value) {
            this.$emit('add-to-search', value);
        }
    }
}
</script>
